import { request } from "../utils/request";
import { BACKEND_BASE_URL } from "./Resolver";

export class Logout {
  public static async logout(): Promise<void> {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/logout`);
    await request(url, { method: "POST" }, true, "Successfully logged out");
  }
}
